import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { useVersionCheck } from "../../hooks/useVersionCheck";
import { BACKGROUND_COLORS, PRIMARY_COLORS, TEXT_COLORS } from "../../constants/design/colors";
import { BORDER_RADIUS, SPACING } from "../../constants/design/spacing";
import { FONT_SIZE } from "../../constants/design/fontSize";

const PositionWrapper = styled.div`
  position: fixed;
  top: ${SPACING.three}px;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  pointer-events: none;
`;

const Wrapper = styled(motion.div)`
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: ${SPACING.three}px;
  padding: ${SPACING.twoHalf}px ${SPACING.three}px;
  background: ${BACKGROUND_COLORS.eight};
  border: 1px solid ${PRIMARY_COLORS.three};
  border-radius: ${BORDER_RADIUS.three}px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  color: ${TEXT_COLORS.one};
  font-size: ${FONT_SIZE.one};
  max-width: 420px;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.span`
  color: ${TEXT_COLORS.one};
`;

const Subtitle = styled.span`
  color: ${TEXT_COLORS.two};
  font-size: ${FONT_SIZE.xs};
`;

const ReloadButton = styled.button`
  appearance: none;
  border: none;
  background: ${PRIMARY_COLORS.one};
  color: ${PRIMARY_COLORS.on};
  font-size: ${FONT_SIZE.one};
  padding: ${SPACING.two}px ${SPACING.three}px;
  border-radius: ${BORDER_RADIUS.two}px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;

export function UpdateAvailableBanner() {
  const { updateAvailable, reload, remoteVersion } = useVersionCheck();

  return (
    <PositionWrapper>
      <AnimatePresence>
        {updateAvailable && (
          <Wrapper
            initial={{ opacity: 0, y: -16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.25 }}
            role="status"
          >
            <TextBlock>
              <Title>New version available</Title>
              <Subtitle>
                Reload to get the latest update{remoteVersion ? ` (${remoteVersion.slice(0, 14)})` : ""}.
              </Subtitle>
            </TextBlock>
            <ReloadButton onClick={reload}>Reload</ReloadButton>
          </Wrapper>
        )}
      </AnimatePresence>
    </PositionWrapper>
  );
}

export default UpdateAvailableBanner;
